import React, { Component } from 'react';
import { connect } from 'react-redux';
import '../../user/component/updateProfile.scss';
import { Button } from 'antd';
import NoImage from "../../../images/no-image.jpg";
import EditIcon from "../../../images/edit-icon.png";
import { imageEndpoint } from '../../../services/endpoint';
import { uploadIdentityverification, approveRejectIdentifyVerification, approveRejectUserDocument } from '../../user/action/user.actions'

class ApproveIdentifyVerification extends Component {

  constructor(props) {
    super(props);
    this.state = {
      document: [],
      identifyVerification:{}
    }
  }

  componentWillReceiveProps(props){
    const { user, userDetails } = props;
    const identifyVerification =  user.role.name == 'Admin' ? (userDetails.identity_verification ) || [] : (user.identity_verification) || [];
    const document = user.role.name == 'Admin' ? (userDetails.identity_verification && userDetails.identity_verification.documents) || [] : (user.identity_verification && user.identity_verification.documents) || [];
    this.setState({document:document, identifyVerification: identifyVerification });
  }

  createFormData = (body) => {
    let data = new FormData();
    Object.keys(body).forEach(key => {
      data.append(key, body[key]);
    });
    return data;
  };

  toBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  }

  onSelectFile = (e, document_type) => {
    const { user, dispatch } = this.props;
    let file = e.target.files[0];
    let formData = this.createFormData({
      file: file,
      user_id: user.id,
      document_name: document_type,
      document_type: file.type
    });
    for (var key of formData.entries()) {
      console.log(key[0] + ', ' + JSON.stringify(key[1]));
    }
    dispatch(uploadIdentityverification(user.id, formData))
  }
  approveRejectUserDocument = (id, status) => {
    const { dispatch, user } = this.props;
    const data = {
      document_id: id,
      status: status
    }
    dispatch(approveRejectUserDocument(data, user.id)).then((res) => {
      let doc = [...this.state.document];
      let currentDoc = doc.find(e => e.id == id);
      currentDoc.status = status == "V" ? "Verified" : "Rejected";
      this.setState({document: doc})
    })
    .catch((err) => {
      console.Consolelog(err);
    })
  }
  approveRejectIdentifyVerification = (id, status) => {
    const { dispatch } = this.props;
    const data = {
      user_id: id,
      status: status
    }
    dispatch(approveRejectIdentifyVerification(data)).then((res)=>{
      let doc = this.state.identifyVerification;
      doc.status = status == "V" ? "Verified" : "Rejected";
      this.setState({identifyVerification: doc})
    })
    .catch((err) => {
      console.log(err);
    })
  }


  render() {
    const { user, userDetails } = this.props;
    const {document, identifyVerification} = this.state;
    const role = user.role.name
    return (
      <div className="form-main-cont-box">
        <div className="upload-heading-txt">
          Identify Verification
          {
            role == "Admin" &&
            <span className='verification-button-container'>
              <Button type="button" disabled={identifyVerification.status === "Verified"} className="ant-btn btn-login" onClick={() => { this.approveRejectIdentifyVerification(userDetails.id, 'V') }} ><span>{identifyVerification.status == "Verified" ? 'Approved' : "Approve Identify Verification"}</span></Button>
              <Button type="button" disabled={identifyVerification.status === "Rejected"} className="ant-btn btn-reject" onClick={() => { this.approveRejectIdentifyVerification(userDetails.id,'R') }}><span>{identifyVerification.status == "Rejected" ? 'Rejected' : "Reject Identify Verifications"}</span></Button>
            </span>
          }
        </div>
        <div className="upload-sub-txt">Upload Minimun 3 document</div>
        <form className="form-container-box">
          {
            document && document.length > 0 && document.map(doc => (
              <div className='col-sm-12 col-md-4 col-xs-12'>
                <div style={{display: "grid"}}>
                  <label className="redio-lavel-txt">{doc.document_name}</label>
                  <div className="doc-img-box">
                    <div className="upload-btn-wrapper">
                      <img src={EditIcon} className="doc-edit-icon" alt="" />
                      <input type="file" name="myfile" onChange={(e) => { this.onSelectFile(e, doc.document_name) }} />
                    </div>

                    <img src={doc && doc.document_url ? imageEndpoint + doc.document_url : NoImage} className="update-prof-img-box" alt="" />

                  </div>
                  {
                    role === "Admin" &&
                    <div style={{display: 'flex', justifyContent: 'space-around'}}>
                      <Button disabled={doc.status === "Verified"} type="button" className="ant-btn btn-login" onClick={() => { this.approveRejectUserDocument(doc.id, 'V') }}><span>{doc.status == "Verified" ? 'Approved' : "Approve"}</span></Button>
                      <Button disabled={doc.status === "Rejected"} type="button" className="ant-btn btn-reject" onClick={() => { this.approveRejectUserDocument(doc.id, 'R') }}><span>{doc.status == "Rejected" ? 'Rejected' : "Reject"}</span></Button>
                    </div>
                  }

                </div>
              </div>
            ))
          }
        </form>
      </div>

    )
  }
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  return {
    user,
  }
}
export default connect(mapStateToProps)(ApproveIdentifyVerification);